import React, { useEffect, useState } from "react";
import { useBotbRAFContext } from "../context";
import { ReferAFriendStatistics } from "./ReferAFriendStatistics";
import CloseModalIcon from "../../../shared-components/icons/CloseModalIcon";
import { ReferAFriendInvitePopup } from "@/app/(custom-header)/botb-refer-a-friend/components/ReferAFriendInvitePopup";
import { toast } from "react-toastify";
import ToastNotification from "@/app/components/ToastNotification/toastNotification";
import { useIsMobile } from "@/app/redux/features/device/selectors";

export const ReferAFriendDetailsModal = (props: any): React.ReactNode => {
  const {
    setShowMoreDetails,
    statistics,
    rafStatus,
    calculatePercentage,
    loading,
    preSubscriptionData,
    showInviteFriendsPopup,
    inviteFriendsPopup,
  } = useBotbRAFContext();
  const { tab } = props;
  const isMobile = useIsMobile();

  const howItWorks = {
    recTitle: "Invite your friends to join BOTB Pass",
    recDesc: `You can invite up to ${loading ? "" : rafStatus.maximumInvites} friends`,
    friendTitle: "Your friend subscribes",
    friendDesc: "They join BOTB Pass with an active subscription.",
    bothTitle: "You both win",
    bothDesc: `You receive £${loading ? "" : rafStatus.cashPerInvite}, and they receive ${preSubscriptionData?.offer?.description ? preSubscriptionData?.offer?.description : ""}.`,
    tab1Title: "How it works",
    tab2Title: "Extra £410 Milestones",
    tab2SubTitle: " Milestones Completed",
    sendInviteBtnNoFriends: "Invite friends",
    milestones: statistics.filter(item => item.tasks?.[0]?.is_completed === true).length,
    shareDetails: "Invitation link: ",
    failSafeCopyUrl: "Your link has been copied",
  };

  const [activeTab, setActiveTab] = useState(tab);
  useEffect(() => {
    document.querySelector("body").classList.add("!overflow-hidden");

    return () => {
      document.querySelector("body").classList.remove("!overflow-hidden");
    };
  }, []);

  const clickInviteFriends = () => {
    if (isMobile) {
      showInviteFriendsPopup();
    } else {
      try {
        navigator.share({
          text: howItWorks.shareDetails,
          url: `${rafStatus.referralUrl}`,
        });
      } catch (e) {
        toast.warning(<ToastNotification message={howItWorks.failSafeCopyUrl} />);
        navigator.clipboard.writeText(`${rafStatus.referralUrl}`);
      }
    }
  };
  return (
    <>
      <div data-name="Overlay" className="fixed-theme inset-0 z-[9999] bg-black/80"></div>
      <div
        data-name="PopupContainer"
        className={"fixed-theme inset-0 z-[99999] w-full min-h-full overflow-x-hidden overflow-y-hidden"}>
        <div className={"w-full min-h-full flex-center flex-col m-auto"}>
          <div
            className={
              "bg-white font-jost relative w-full flex flex-col max-lg:grow lg:rounded-2xl lg:max-w-[600px] lg:h-[650px] lg:max-h-[650px]"
            }>
            {/*body*/}
            <div className={""}>
              <div className={"sticky top-0 bg-white lg:rounded-t-2xl"}>
                <div className={"flex items-center justify-end h-10 lg:h-8"}>
                  <button
                    onClick={() => setShowMoreDetails({ show: false, tab: 0 })}
                    className={"mr-2 mt-2 lg:mr-4 lg:mt-4"}>
                    <CloseModalIcon className={"size-6 text-gray-5"} />
                  </button>
                </div>

                {/*tabs menu*/}
                <div
                  className={
                    "flex items-center w-full text-sm lg:text-base font-medium leading-5 lg:leading-5.5 h-14 lg:h-[70px] lg:mt-9 lg:px-10 lg:mx-auto"
                  }>
                  <div
                    className={`w-1/2 h-full flex-center text-center border-b cursor-pointer ${activeTab === 0 ? "border-primary text-primary" : "border-black/8 text-gray-1"}`}
                    onClick={() => {
                      setActiveTab(0);
                    }}>
                    {howItWorks.tab1Title}
                  </div>
                  <div
                    className={`w-1/2 h-full flex-center flex-col text-center border-b cursor-pointer ${activeTab === 1 ? "border-primary text-primary" : "border-black/8 text-gray-1"}`}
                    onClick={() => {
                      setActiveTab(1);
                    }}>
                    <div className={"mb-1"}>{howItWorks.tab2Title}</div>
                    <div className={"text-[10px] lg:text-sm leading-3 lg:leading-5 font-normal text-gray-1"}>
                      {howItWorks.milestones === statistics.length && <span>🎉</span>}
                      <strong className={"text-dark-1 font-medium"}>{howItWorks.milestones}</strong>/
                      <span>{statistics.length}</span>
                      {howItWorks.tab2SubTitle}
                    </div>
                  </div>
                </div>
              </div>

              {/*content*/}
              <div className={"pb-16"}>
                {/*tabs content 386px*/}
                {activeTab === 0 && (
                  <div className={"pt-7 max-lg:pl-4 max-lg:pr-5 lg:max-w-[386px] lg:mx-auto"}>
                    <div className={""}>
                      {/*#1 rec*/}
                      <div className={"flex items-center gap-1.5 lg:gap-3 mb-8 lg:mb-8"}>
                        <div
                          className={
                            "relative size-10 lg:size-12 min-w-10 lg:min-w-12 rounded-full flex-center bg-gray-11"
                          }>
                          <div
                            className={
                              "absolute -top-[5px] -left-[5px] flex-center rounded-full bg-primary size-4.5 text-white text-xs leading-4 text-center"
                            }>
                            1
                          </div>
                          <svg
                            xmlns="http://www.w3.org/2000/svg"
                            width="20"
                            height="20"
                            viewBox="0 0 20 20"
                            fill="none"
                            className={"size-5 lg:size-6"}>
                            <g clip-path="url(#clip0_51319_3540)">
                              <path
                                d="M6.66602 5.83333C6.66602 6.71739 7.0172 7.56524 7.64233 8.19036C8.26745 8.81548 9.11529 9.16667 9.99935 9.16667C10.8834 9.16667 11.7313 8.81548 12.3564 8.19036C12.9815 7.56524 13.3327 6.71739 13.3327 5.83333C13.3327 4.94928 12.9815 4.10143 12.3564 3.47631C11.7313 2.85119 10.8834 2.5 9.99935 2.5C9.11529 2.5 8.26745 2.85119 7.64233 3.47631C7.0172 4.10143 6.66602 4.94928 6.66602 5.83333Z"
                                stroke="black"
                                stroke-opacity="0.5"
                                stroke-linecap="round"
                                stroke-linejoin="round"
                              />
                              <path
                                d="M13.332 15.832H18.332"
                                stroke="black"
                                stroke-opacity="0.5"
                                stroke-linecap="round"
                                stroke-linejoin="round"
                              />
                              <path
                                d="M15.832 13.332V18.332"
                                stroke="black"
                                stroke-opacity="0.5"
                                stroke-linecap="round"
                                stroke-linejoin="round"
                              />
                              <path
                                d="M5 17.5V15.8333C5 14.9493 5.35119 14.1014 5.97631 13.4763C6.60143 12.8512 7.44928 12.5 8.33333 12.5H11.6667"
                                stroke="black"
                                stroke-opacity="0.5"
                                stroke-linecap="round"
                                stroke-linejoin="round"
                              />
                            </g>
                            <defs>
                              <clipPath id="clip0_51319_3540">
                                <rect width="20" height="20" fill="white" />
                              </clipPath>
                            </defs>
                          </svg>
                          {/*vertical line*/}
                          <div
                            className={
                              "absolute top-[calc(100%+13px)] lg:top-[calc(100%+15px)] left-1/2 -translate-x-1/2 w-0.5 h-6 rounded-full bg-gray-11"
                            }></div>
                        </div>
                        <div className={"w-full"}>
                          <div className={"text-dark-1 text-sm lg:text-lg leading-5 lg:leading-6 font-medium"}>
                            {howItWorks.recTitle}
                          </div>
                          <div className={"text-gray-1 text-sm lg:text-base leading-4 lg:leading-5.5 font-normal"}>
                            {howItWorks.recDesc}
                          </div>
                          {/*progress bar*/}
                          <div className={"pt-2 w-full lg:max-w-[288px]"}>
                            <div className={"mb-[7px] h-2 rounded-full w-full bg-gray-6"}>
                              <div
                                className={`h-full rounded-full  ${rafStatus.referredFriends === rafStatus.maximumInvites ? "bg-green-1" : "bg-primary"}`}
                                style={{
                                  width: calculatePercentage(
                                    rafStatus.referredFriends > rafStatus.maximumInvites
                                      ? rafStatus.maximumInvites
                                      : rafStatus.referredFriends,
                                    rafStatus.maximumInvites
                                  ),
                                }}></div>
                            </div>
                            <div className={"text-sm lg:text-base font-medium leading-4 lg:leading-5.5 text-gray-5"}>
                              {rafStatus.referredFriends === rafStatus.maximumInvites && (
                                <span>🎉 Congratulations!</span>
                              )}{" "}
                              <span>{rafStatus.referredFriends}</span>/<span>{rafStatus.maximumInvites}</span> friend
                              {rafStatus.referredFriends > 1 && "s"} invited
                            </div>
                          </div>
                        </div>
                      </div>

                      {/*#2 friend*/}
                      <div className={"flex items-center gap-1.5 lg:gap-3 mb-10 lg:mb-11"}>
                        <div
                          className={
                            "relative size-10 lg:size-12 min-w-10 lg:min-w-12 rounded-full flex-center bg-gray-11"
                          }>
                          <div
                            className={
                              "absolute -top-[5px] -left-[5px] flex-center rounded-full bg-primary size-4.5 text-white text-xs leading-4 text-center"
                            }>
                            2
                          </div>
                          <svg
                            xmlns="http://www.w3.org/2000/svg"
                            width="20"
                            height="20"
                            viewBox="0 0 20 20"
                            fill="none"
                            className={"size-5 lg:size-6"}>
                            <path
                              fill-rule="evenodd"
                              clip-rule="evenodd"
                              d="M11.0048 10V6.25C11.0048 5.56 10.4448 5 9.75476 5C9.06476 5 8.50476 5.56 8.50476 6.25V12.5L6.81143 11.9358C6.31726 11.7708 5.77226 11.9 5.4031 12.2683C4.8306 12.8408 4.87393 13.78 5.49476 14.2983L8.87393 17.1142C9.17476 17.3633 9.55226 17.5 9.94143 17.5H13.6998C14.5406 17.5 15.2489 16.8742 15.3539 16.04L15.8064 12.4208C15.9173 11.5333 15.3081 10.7175 14.4264 10.57L11.0048 10Z"
                              stroke="#797979"
                              stroke-linecap="round"
                              stroke-linejoin="round"
                            />
                            <path
                              d="M6 8H4C2.89543 8 2 7.10457 2 6V4C2 2.89543 2.89543 2 4 2H14C15.1046 2 16 2.89543 16 4V6C16 7.10457 15.1046 8 14 8H12.5M4 5L5 6L6.5 3.5"
                              stroke="#797979"
                              stroke-linecap="round"
                              stroke-linejoin="round"
                            />
                          </svg>
                          {/*vertical line*/}
                          <div
                            className={
                              "absolute top-[calc(100%+13px)] lg:top-[calc(100%+15px)] left-1/2 -translate-x-1/2 w-0.5 h-6 rounded-full bg-gray-11"
                            }></div>
                        </div>
                        <div className={"w-full"}>
                          <div className={"text-dark-1 text-sm lg:text-lg leading-5 lg:leading-6 font-medium"}>
                            {howItWorks.friendTitle}
                          </div>
                          <div className={"text-gray-1 text-sm lg:text-base leading-4 lg:leading-5.5 font-normal"}>
                            {howItWorks.friendDesc}
                          </div>
                        </div>
                      </div>

                      {/*#3 both*/}
                      <div className={"flex items-center gap-1.5 lg:gap-3"}>
                        <div
                          className={
                            "relative size-10 lg:size-12 min-w-10 lg:min-w-12 rounded-full flex-center bg-gray-11"
                          }>
                          <div
                            className={
                              "absolute -top-[5px] -left-[5px] flex-center rounded-full bg-primary size-4.5 text-white text-xs leading-4 text-center"
                            }>
                            3
                          </div>
                          <svg
                            xmlns="http://www.w3.org/2000/svg"
                            width="20"
                            height="20"
                            viewBox="0 0 20 20"
                            fill="none"
                            className={"size-5 lg:size-6"}>
                            <path
                              d="M5.105 11.5L2.5 14.1667L4.58333 15.4167L5.83333 17.5L9.0825 14.0875"
                              stroke="#797979"
                              stroke-linecap="round"
                              stroke-linejoin="round"
                            />
                            <path
                              d="M10.918 14.0875L14.1671 17.5L15.4171 15.4167L17.5005 14.1667L14.8955 11.5"
                              stroke="#797979"
                              stroke-linecap="round"
                              stroke-linejoin="round"
                            />
                            <path
                              d="M14.1241 4.20854C16.4022 6.4866 16.4022 10.1801 14.1241 12.4581C11.8461 14.7362 8.15262 14.7362 5.87456 12.4581C3.5965 10.1801 3.5965 6.4866 5.87456 4.20854C8.15262 1.93049 11.8461 1.93049 14.1241 4.20854"
                              stroke="#797979"
                              stroke-linecap="round"
                              stroke-linejoin="round"
                            />
                            <path
                              fill-rule="evenodd"
                              clip-rule="evenodd"
                              d="M9.99966 10.4867L11.4972 11.2734C11.7888 11.4267 12.1297 11.1792 12.0738 10.8542L11.788 9.18675L12.9997 8.00674C13.2355 7.77674 13.1055 7.37591 12.7797 7.32841L11.1055 7.08508L10.3572 5.56758C10.2113 5.27174 9.7905 5.27174 9.64466 5.56758L8.89633 7.08508L7.22133 7.32924C6.8955 7.37674 6.7655 7.77758 7.00133 8.00758L8.213 9.18758L7.92716 10.8551C7.87133 11.1801 8.21216 11.4276 8.50383 11.2742L10.0013 10.4876H9.99966V10.4867Z"
                              stroke="#797979"
                              stroke-linecap="round"
                              stroke-linejoin="round"
                            />
                          </svg>
                        </div>
                        <div className={"w-full"}>
                          <div className={"text-dark-1 text-sm lg:text-lg leading-5 lg:leading-6 font-medium"}>
                            {howItWorks.bothTitle}
                          </div>
                          <div className={"text-gray-1 text-sm lg:text-base leading-4 lg:leading-5.5 font-normal"}>
                            {howItWorks.bothDesc}
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                )}
                {activeTab === 1 && (
                  <div className={"pt-6"}>
                    <ReferAFriendStatistics />
                  </div>
                )}
              </div>
              {/*content END*/}
            </div>
            {/*body END*/}
            <div
              data-name={"stickyBannerButton"}
              className={`w-full p-4 pt-2 px-6 bg-white lg:rounded-b-2xl max-lg:fixed-theme lg:absolute left-0 right-0 bottom-0 z-[1003] shadow-[0px_0px_20px_0px_rgba(0,0,0,0.20)] ${activeTab === 0 ? "lg:shadow-none lg:pb-6" : ""}`}>
              <button
                className={"theme-btn theme-btn-primary w-full uppercase lg:w-[420px] lg:mx-auto lg:flex"}
                type={"button"}
                onClick={clickInviteFriends}>
                {howItWorks.sendInviteBtnNoFriends}
              </button>
            </div>
            {inviteFriendsPopup && <ReferAFriendInvitePopup />}
          </div>
        </div>
      </div>
    </>
  );
};
